import './i18n/i18n-side-effect';

import { camelCase } from 'lodash';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';

import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/utils';

import { AppWidget } from './AppWidget';
import '@app/styles/index-widget.scss';

ClassNameGenerator.configure((componentName) => camelCase(componentName.replace('Mui', '')));

// needed to handle conflicts with WordPress styles on PROD
document.querySelector('html')?.classList.add('twRoot');
document.body.classList.add('twRoot');
document.body.id = 'twRoot';

ReactDOM.render(
  <React.StrictMode>
    {/* TODO show nice loader */}
    <Suspense fallback={<div className="h-full text-center">loading...</div>}>
      <AppWidget />
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);
